import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import AdNav from "../components/adNav";
import Time from "../components/time";
import { Link } from "react-router-dom";

const Menu_orders = () => {

  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [dept, setDept] = useState("");
  const [subDept, setSubDept] = useState("");


  useEffect(() => {
    fetchData();
  }, [dept ,subDept ]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/adminMenu_orderList", {
        params: { dept: dept, subDept: subDept }
      });
      setData(response.data.ListData);
      setFilteredData(response.data.ListData);
    } catch (error) {
      console.error("Error fetching ListData:", error);
    } finally {
      setLoading(false);
    }
  };
  
const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    if (term === "") {
        setFilteredData(data);
        return;
    }

    const filtered = data.filter((item) => 
        String(item.title || "").toLowerCase().includes(term) || 
        String(item.links || "").toLowerCase().includes(term)
    );

    setFilteredData(filtered);
};
  


  // Pagination
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div id="admin-container">
      <AdNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Menu Order List</h2>
          <Time />
        </section>



        {/* Month & Year Selection */}
        <div className="month-year-container">
          <p className="title">Department:</p>

          <div className="select-container">
            <select
              value={dept}
              onChange={(e) => setDept(e.target.value)}
              className="custom-select"
            >
              <option value='Vehicle'>Vehicle</option>
              <option value='Inventory'>Inventory</option>
            </select>
            </div>

<div className="select-container">
            <p className="title">Sub Department:</p>
            <select
              value={subDept}
              onChange={(e) => setSubDept(e.target.value)}
              className="custom-select"
            >
              <option value='Master'>Master</option>
              <option value='master1'>Master I</option>
              <option value='Master II'>Master II</option>
              <option value='Modules'>Modules</option>
              <option value='transaction'>Transaction</option>
              <option value='Report'>Report</option>
              <option value='Report - I'>Report - I</option>
              <option value='Report - II'>Report II</option>
            </select>
          </div>

                <button
  className="custom-button"
  onClick={() => {
    window.location.href = '/admin/menu_orders';
  }}
>
  View All
</button>
        </div>

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by Menu Title"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        {/* Table */}
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Department</th>
                <th>Sub Department</th>
                <th>Orders</th>
                <th>Menu Title</th>
                <th>Link Page</th>
                <th>Orders Update</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="loading-text">Loading data, please wait...</td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{item.department}</td>
                    <td>{item.subdepartment}</td>
                    <td>{item.orders}</td>
                    <td>{item.title}</td>
                    <td>{item.links}</td>
                    <td>
                      <Link to={`/admin/admin_Menu_edit/${item.SlNo}`}>
                        Edit
                      </Link>
                    </td>
                    
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>

          {/* Always show first page */}
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }

          {/* Next button */}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Menu_orders;
